"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.removeReply = exports.isGmailReplyBlockquote = exports.OFFICE_365_REPLY_ID = exports.REPLY_CLASSLIST = exports.GMAIL_QUOTE = void 0;

var _SanitizeConfiguration = require("../sanitizers/SanitizeConfiguration");

var GMAIL_QUOTE = 'gmail_quote';
exports.GMAIL_QUOTE = GMAIL_QUOTE;
var REPLY_CLASSLIST = [// Gmail
'gmail_extra', GMAIL_QUOTE, // HubSpot
'hs_reply', 'x_hs_reply_wrap'];
exports.REPLY_CLASSLIST = REPLY_CLASSLIST;
var OFFICE_365_REPLY_ID = 'divRplyFwdMsg';
/**
 *
 * All Gmail email bodies are wrapped in a div that specifies the direction (dir) of the text
 * in the email like so:
 *
 * @example
 * <div dir="ltr">
 *
 * Thus, a formatted quote in a Gmail email is wrapped in such a div (we want to leave these in tact)
 *
 * @example
 * <div dir="ltr">
 *   <blockquote class="gmail_quote"> my quote </blockquote>
 * </div>
 *
 * However, Gmail replies are wrapped the other way around (we want to remove these replies)
 *
 * @example
 * <blockquote class="gmail_quote">
 *   <div dir="ltr"> my reply </div>
 * </blockquote>
 *
 * @description
 * Thus, if a blockquote has a child <div dir="ltr">, we can assume that it is
 * a reply that we want to remove. Otherwise, it is a formatted quote that we
 * want to leave in tact.
 *
 */

exports.OFFICE_365_REPLY_ID = OFFICE_365_REPLY_ID;

var isGmailReplyBlockquote = function isGmailReplyBlockquote(node) {
  return node.querySelector('div[dir]');
};

exports.isGmailReplyBlockquote = isGmailReplyBlockquote;

var isReply = function isReply(classList, id) {
  return id === OFFICE_365_REPLY_ID || classList && classList.contains && REPLY_CLASSLIST.some(function (className) {
    return classList.contains(className);
  });
};

var removeReply = function removeReply(_ref) {
  var node = _ref.node;
  var classList = node.classList,
      id = node.id,
      _node$attributes = node.attributes,
      attributes = _node$attributes === void 0 ? [] : _node$attributes;

  if (isReply(classList, id)) {
    if (classList.contains(GMAIL_QUOTE) && !isGmailReplyBlockquote(node)) {
      return null;
    }

    var span = _SanitizeConfiguration.secureDocument.createElement('span');

    Object.keys(attributes).forEach(function (key) {
      var attribute = attributes[key];
      span.setAttribute(attribute.nodeName, attribute.nodeValue);
    });
    span.innerHTML = '';
    span.setAttribute('data-email-reply', '');
    return {
      node: span
    };
  }

  return null;
};

exports.removeReply = removeReply;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/sanitize-text/static-1.1206/js/transformers/removeReply.js
// module id = 399
// module chunks = 209 210 211 212